import React from "react";

import "./RDXPage.scss";

export const RDXPage = () => {
  return <div className="RDX">RDXPage</div>;
};
